var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetItGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 56,
    fill: "none",
    viewBox: "0 0 192 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M184.889 56H7.111C3.13 56 0 52.92 0 49V7c0-3.92 3.129-7 7.111-7H184.89C188.871 0 192 3.08 192 7v42c0 3.92-3.129 7-7.111 7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M67.413 14.28c0 1.12-.284 2.1-.995 2.8-.854.84-1.85 1.26-3.13 1.26-1.28 0-2.275-.42-3.128-1.26-.853-.84-1.28-1.82-1.28-3.08s.427-2.24 1.28-3.08c.853-.84 1.849-1.26 3.129-1.26.569 0 1.138.14 1.707.42.568.28.995.56 1.28.98l-.712.7c-.568-.7-1.28-.98-2.275-.98-.853 0-1.707.28-2.276.98-.71.56-.995 1.4-.995 2.38s.284 1.82.995 2.38c.711.56 1.423.98 2.276.98.995 0 1.707-.28 2.418-.98.426-.42.71-.98.71-1.68H63.29v-1.12h4.124v.56zM73.956 10.78h-3.84v2.66h3.555v.98h-3.555v2.66h3.84v1.12h-4.978V9.8h4.978v.98zM78.649 18.2H77.51v-7.42h-2.418V9.8h5.974v.98h-2.418v7.42zM85.191 18.2V9.8h1.138v8.4H85.19zM91.164 18.2h-1.137v-7.42h-2.418V9.8h5.831v.98h-2.418v7.42h.142zM104.676 17.08c-.854.84-1.849 1.26-3.129 1.26s-2.276-.42-3.13-1.26c-.853-.84-1.28-1.82-1.28-3.08s.427-2.24 1.28-3.08c.854-.84 1.85-1.26 3.13-1.26 1.28 0 2.275.42 3.129 1.26.853.84 1.28 1.82 1.28 3.08s-.427 2.24-1.28 3.08zm-5.405-.7c.569.56 1.422.98 2.276.98.853 0 1.706-.28 2.275-.98.569-.56.996-1.4.996-2.38s-.285-1.82-.996-2.38c-.569-.56-1.422-.98-2.275-.98-.854 0-1.707.28-2.276.98-.569.56-.995 1.4-.995 2.38s.284 1.82.995 2.38zM107.52 18.2V9.8h1.28l4.124 6.58V9.8h1.138v8.4h-1.138l-4.408-6.86V18.2h-.996z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96.853 30.52c-3.413 0-6.115 2.52-6.115 6.02 0 3.36 2.702 6.02 6.115 6.02 3.414 0 6.116-2.52 6.116-6.02 0-3.64-2.702-6.02-6.116-6.02zm0 9.52c-1.849 0-3.413-1.54-3.413-3.64s1.564-3.64 3.413-3.64c1.85 0 3.414 1.4 3.414 3.64 0 2.1-1.565 3.64-3.414 3.64zm-13.226-9.52c-3.414 0-6.116 2.52-6.116 6.02 0 3.36 2.702 6.02 6.116 6.02 3.413 0 6.115-2.52 6.115-6.02 0-3.64-2.702-6.02-6.115-6.02zm0 9.52c-1.85 0-3.414-1.54-3.414-3.64s1.565-3.64 3.414-3.64c1.849 0 3.413 1.4 3.413 3.64 0 2.1-1.564 3.64-3.413 3.64zm-15.787-7.7v2.52h6.116c-.143 1.4-.712 2.52-1.423 3.22-.853.84-2.275 1.82-4.693 1.82-3.84 0-6.684-2.94-6.684-6.72s2.986-6.72 6.684-6.72c1.991 0 3.556.84 4.693 1.82l1.85-1.82c-1.565-1.4-3.556-2.52-6.4-2.52-5.12 0-9.53 4.2-9.53 9.24s4.41 9.24 9.53 9.24c2.844 0 4.835-.84 6.541-2.66 1.707-1.68 2.276-4.06 2.276-5.88 0-.56 0-1.12-.142-1.54H67.84zm64.569 1.96c-.569-1.4-1.991-3.78-5.12-3.78s-5.689 2.38-5.689 6.02c0 3.36 2.56 6.02 5.973 6.02 2.703 0 4.409-1.68 4.978-2.66l-1.991-1.4c-.711.98-1.564 1.68-2.987 1.68-1.422 0-2.275-.56-2.986-1.82l8.106-3.36-.284-.7zm-8.249 1.96c0-2.24 1.849-3.5 3.129-3.5.995 0 1.991.56 2.275 1.26l-5.404 2.24zM117.476 42h2.702V24.5h-2.702V42zm-4.267-10.22c-.711-.7-1.849-1.4-3.271-1.4-2.987 0-5.831 2.66-5.831 6.02 0 3.36 2.702 5.88 5.831 5.88 1.422 0 2.56-.7 3.129-1.4h.142v.84c0 2.24-1.28 3.5-3.271 3.5-1.565 0-2.702-1.12-2.987-2.1l-2.275.98c.711 1.54 2.417 3.5 5.404 3.5 3.129 0 5.689-1.82 5.689-6.16V30.8h-2.56v.98zm-3.129 8.26c-1.849 0-3.413-1.54-3.413-3.64s1.564-3.64 3.413-3.64c1.849 0 3.271 1.54 3.271 3.64s-1.422 3.64-3.271 3.64zm34.702-15.54h-6.4V42h2.702v-6.58h3.698c2.987 0 5.831-2.1 5.831-5.46s-2.844-5.46-5.831-5.46zm.142 8.4h-3.84v-6.02h3.84c1.992 0 3.129 1.68 3.129 2.94-.142 1.54-1.28 3.08-3.129 3.08zm16.356-2.52c-1.991 0-3.982.84-4.693 2.66l2.417.98c.569-.98 1.423-1.26 2.418-1.26 1.422 0 2.702.84 2.845 2.24v.14c-.427-.28-1.565-.7-2.703-.7-2.56 0-5.12 1.4-5.12 3.92 0 2.38 2.134 3.92 4.409 3.92 1.849 0 2.703-.84 3.414-1.68h.142V42h2.56v-6.72c-.285-3.08-2.702-4.9-5.689-4.9zm-.284 9.66c-.854 0-2.134-.42-2.134-1.54 0-1.4 1.565-1.82 2.845-1.82 1.137 0 1.706.28 2.417.56-.284 1.68-1.706 2.8-3.128 2.8zm14.933-9.24l-2.987 7.56h-.142l-3.129-7.56h-2.844l4.693 10.64-2.702 5.88h2.702l7.253-16.52h-2.844zM152.036 42h2.702V24.5h-2.702V42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M14.791 10.5c-.427.42-.569 1.12-.569 1.96V43.4c0 .84.285 1.54.711 1.96l.143.14L32.71 28.14v-.28L14.791 10.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M38.4 34.02l-5.831-5.74V27.86l5.831-5.74.142.14 6.97 3.92c1.99 1.12 1.99 2.94 0 4.06L38.4 34.02z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M38.542 33.88L32.57 28 14.79 45.5c.711.7 1.707.7 2.987.14l20.764-11.76z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M38.542 22.12L17.778 10.5c-1.28-.7-2.276-.56-2.987.14L32.57 28l5.973-5.88z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.4 33.74L17.778 45.22c-1.138.7-2.134.56-2.845 0l-.142.14.142.14c.711.56 1.707.7 2.845 0L38.4 33.74z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.791 45.22c-.427-.42-.569-1.12-.569-1.96v.14c0 .84.285 1.54.711 1.96v-.14h-.142zM45.511 29.82L38.4 33.74l.142.14 6.97-3.92c.995-.56 1.421-1.26 1.421-1.96 0 .7-.569 1.26-1.422 1.82z",
    opacity: 0.12
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.778 10.64L45.51 26.18c.853.56 1.422 1.12 1.422 1.82 0-.7-.426-1.4-1.422-1.96L17.778 10.5c-1.991-1.12-3.556-.28-3.556 1.96v.14c0-2.1 1.565-3.08 3.556-1.96z",
    opacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 31.004,
    x2: 7.511,
    y1: 12.194,
    y2: 36.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 48.12,
    x2: 13.707,
    y1: 28.002,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 35.309,
    x2: 3.452,
    y1: 31.215,
    y2: 63.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.378,
    x2: 24.604,
    y1: 0.247,
    y2: 14.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetItGooglePlay);
export default __webpack_public_path__ + "static/media/getItGooglePlay.b9a92daa7ed1fffc8d99cd7ddd4fadbf.svg";
export { ForwardRef as ReactComponent };